import Vue from 'vue'
import Vuex from 'vuex'
import Contributor from './modules/contributor/index'
import Authentication from './modules/authentication'
import BrowseTalent from './modules/browse-talent'
import FindJob from './modules/jobs'
import PostAJob from './modules/post-a-job'
import Profile from './modules/profile'
import MyJob from './modules/my-job'
import Talent from './modules/talent'
import Notification from './modules/notification'
import Settings from './modules/settings'
import EWallet from './modules/e-wallet'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    contributor: Contributor,
    authentication: Authentication,
    browseTalent: BrowseTalent,
    findJob: FindJob,
    PostAJob: PostAJob,
    Profile: Profile,
    myJob: MyJob,
    talent: Talent,
    notification: Notification,
    settings: Settings,
    eWallet: EWallet
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js